import { TooltipIcon } from 'components/icons';
import React from 'react';
import ReactTooltip from 'react-tooltip';
import styles from './tooltipicon.module.scss';
export default function ToolTip({ id, content, ...rest }) {
  return (
    <>
      <p data-tip data-for={id} className={styles.icon} data-testid="tooltip">
        <TooltipIcon style={{ transform: 'scale(1.2)' }} />
      </p>
      <ReactTooltip
        id={id}
        effect="solid"
        {...rest}
        className={styles.tooltip}
        textColor="#222"
        backgroundColor="#32d269"
      >
        <span>{content}</span>
      </ReactTooltip>
    </>
  );
}
